/**
 * Where the public pages link to each other, for brands whose content doesn't say (`content.links`) - in practice
 * HOTmaths; South Africa and India name their own.
 *
 * HOTmaths keeps its JSP pages at the real URLs for now: the homepage at `/` and registration at `/home/register`.
 * Its React versions are kept apart - the homepage at REACT_HOTMATHS_HOME_URL, registration at REGISTER_URL - and
 * the React homepage's "Join now" goes to the React registration page. Links inside the React homepage (its logo,
 * "Home") stay on it.
 *
 * HOME_URL is the logo on the registration and password reset pages: the live homepage. (Password reset is React
 * at /home/reset for HOTmaths too - ResetPasswordAction.showResetPassword.)
 */
export const REGISTER_URL = '/home/registerReact';
export const HOME_URL = '/';
export const REACT_HOTMATHS_HOME_URL = '/home/homeReact';
